import { useAtom } from '@reatom/npm-react'
import { AnimatePresence } from 'motion/react'
import styled from 'styled-components'

import { tradeSettingsDialogParamsAtom } from '../../atoms/options-dialog-atom'

import { TradeSettingsDrawer } from './trade-settings-drawer'

type Props = {}

export const TradeSettingsDrawerController: React.FC<Props> = () => {
  const [params, setParams] = useAtom(tradeSettingsDialogParamsAtom)
  return (
    <Root>
      <AnimatePresence>
        {params ? (
          <TradeSettingsDrawer
            open
            onOpenChange={(open) => {
              if (!open) {
                setParams(undefined)
              }
            }}
          />
        ) : undefined}
      </AnimatePresence>
    </Root>
  )
}

const Root = styled.div``
